export default __webpack_public_path__ + "static/media/InfrastructureSide.391cf4b7.png";